const WisdomDashboardGeneralNumbers = ({ wisdomData, selectedOrg, setEmployeeAbsenceDashboardPopup, filteredEmployeesAbsence }) => {
    return (
        <div className="w-full md:h-[10%] p-2 flex justify-evenly items-center gap-2" style={{
            background: "#2d3347",
            borderRadius: 16,
            boxShadow: '0 2px 8px #0002',
        }}>
            <div className="flex justify-end items-center w-1/4 md:gap-3 gap-1">
                <div className="text-2xl w-fit">{selectedOrg?.id === "All" ? wisdomData?.total.no_of_students : selectedOrg?.id === 15 ? 1123 : selectedOrg?.no_of_students}</div>
                <div className="text-xs text-end w-9">عدد الطلاب</div>
            </div>
            <div className='border-l-2 border-white h-3/4 w-0' />
            <div className="flex justify-end items-center w-1/4 md:gap-3 gap-1">
                <div className="text-2xl w-fit">10</div>
                <div className="text-xs text-end w-8">عدد المواد</div>
            </div>
            <div className='border-l-2 border-white h-3/4 w-0' />
            <div className="flex justify-end items-center w-1/4 md:gap-3 gap-1">
                <div className="text-2xl w-fit">0%</div>
                <div className="text-xs text-end w-[60px]">نسبة تسرب الطلاب</div>
            </div>
            <div className='border-l-2 border-white h-3/4 w-0' />
            <div className="flex justify-end items-center w-1/4 md:gap-3 gap-1 cursor-pointer" onClick={() => setEmployeeAbsenceDashboardPopup(true)}>
                <div className="text-2xl w-fit">{filteredEmployeesAbsence.length}</div>
                <div className="text-xs text-end w-[60px]">عدد غياب الموظفيين</div>
            </div>
        </div>
    )
};

export default WisdomDashboardGeneralNumbers;